<template>
  <div class="d-flex">
    <div class="mr-3">
      <div>
        <v-btn
          @click="addBreaker()"
          color="primary"
          class="btn-pt"
          depressed
          :disabled="breaker[id] > 0"
        >
          <IconPageBreakPlus />
        </v-btn>
      </div>
      <div v-if="breaker[id] > 0">
        <v-hover v-slot="{ hover }">
          <v-btn @click="delBreaker()" color="primary" class="btn-pt" depressed text>
            <v-icon v-if="hover">mdi-close</v-icon>
            <IconPageBreak v-else />
          </v-btn>
        </v-hover>
      </div>
    </div>
    <div>
      <div>
        <v-btn
          @click="addSpacer()"
          color="primary"
          class="btn-pt"
          depressed
          :disabled="spacer[id] > 9"
        >
          <IconPTplus />
        </v-btn>
      </div>
      <div v-for="i in Number(spacer[id])" :key="'0' + i">
        <v-hover v-slot="{ hover }">
          <v-btn @click="delSpacer()" color="primary" class="btn-pt" depressed text>
            <v-icon v-if="hover">mdi-close</v-icon>
            <IconPT v-else />
          </v-btn>
        </v-hover>
      </div>
    </div>
  </div>
</template>

<script>
import IconPageBreak from '../../icons/IconPageBreak'
import IconPageBreakPlus from '../../icons/IconPageBreakPlus'
import IconPT from '../../icons/IconPT'
import IconPTplus from '../../icons/IconPTplus'

export default {
  name: 'ProjectProposedBreakPage',
  components: { IconPTplus, IconPT, IconPageBreakPlus, IconPageBreak },
  props: {
    id: {
      type: Number,
      default: -1,
    },
    breaker: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0, 0, 0]
      },
    },
    spacer: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0, 0, 0]
      },
    },
    fncAddBreaker: {},
    fncDelBreaker: {},
    fncAddSpacer: {},
    fncDelSpacer: {},
  },
  methods: {
    addBreaker() {
      if (this.fncAddBreaker) {
        this.fncAddBreaker(this.id)
      }
    },
    delBreaker() {
      if (this.fncDelBreaker) {
        this.fncDelBreaker(this.id)
      }
    },
    addSpacer() {
      if (this.fncAddSpacer) {
        this.fncAddSpacer(this.id)
      }
    },
    delSpacer() {
      if (this.fncDelSpacer) {
        this.fncDelSpacer(this.id)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.btn-pt {
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
}
</style>
